
/* Auth Routes */
export const AUTH = "/auth";
export const LOGIN = AUTH + "/login";
export const FORGOT_PASSWORD = AUTH + "/forgot-password";
export const RESET_PASSWORD = AUTH + "/reset-password";

/* CourseStructure Routes */
export const COURSE_STRUCTURE = "/courses";
export const COURSE_BOARDS = COURSE_STRUCTURE+"/boards";
export const COURSE_CLASS = COURSE_BOARDS+"/:boardName/:boardId";
export const COURSE_SUBJECTS = COURSE_CLASS+"/:className/:classId";
export const COURSE_CHAPTERS = COURSE_SUBJECTS+"/:subjectName/:subjectId";

/*Content library Routes*/
export const CONTENT_LIBRARY = "/content-library";

/*Tutors*/
export const TUTORS = "/tutors";
export const TUTOR_DETAILS = "/tutors/:tutorId";

/*Exams*/
export const EXAMS = "/exams";
export const EXAM_SUBJECTS = EXAMS + "/:examId/:examName"
export const EXAM_SUBJECT_CHAPTERS = EXAM_SUBJECTS + "/:subjectId/:subjectName"
export const PREVIOUS_PAPER = EXAMS + "/previous_paper/:examId/:examName"

/*Live classes*/
export const LIVE_CLASSES = "/live-classes";

/*Students*/
export const STUDENTS = "/students";
export const STUDENTS_BLACKLIST = "/students-blacklist";
export const STUDENT_DETAILS = "/students/:studentId";
export const STUDENT_ANALYTICS = "/students/:studentId/analytics"
export const STUDENT_ANALYTICS_CHAPTERS_LIST = "/students/:studentId/analytics/:subjectId/chapters"
export const STUDENT_ANALYTICS_EXERCISES_LIST = "/students/:studentId/analytics/:subjectId/chapters/:chapterId/exercises"
 /*Internal users*/
export const INTERNAL_USERS = "/internal-users";

/*Dashboard*/
export const DASHBOARD = "/dashboard";

/*Analytics*/
export const ANALYTICS = "/analytics"
/*Reports*/
export const REPORTS = "/reports"
 
/*Institute */
export const INSTITUTE = "/institute"
export const INSTITUTE_VIEW = INSTITUTE + "/:instituteId"
export const INSTITUTE_STUDENT_VIEW = INSTITUTE_VIEW + "/institute-students/:studentId"
export const INSTITUTE_TEACHER_VIEW = INSTITUTE_VIEW + "/institute-teachers/:teacherId"
export const LIST_ANALYTICS_CHAPTERS = INSTITUTE_VIEW + "/analytics/:subjectId";
export const LIST_ANALYTICS_EXERCISES = LIST_ANALYTICS_CHAPTERS + "/:chapterId";

/*Change Password */
export const CHANGE_PASSWORD = "/change-password"
 

// Generator
export const GENERATOR = "/generator"

//Leaderboard
export const LEADERBOARD = "/leaderboard"

/*Products*/
export const PRODUCTS = "/products"